// extracted by mini-css-extract-plugin
module.exports = {"headerStatus":"search_header_status-module__headerStatus--3C2UH"};